// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SalesTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "SalesId",
      label: "销售订单编号",
      sortable: true
    },
    {
      key: "SalesPoolId",
      label: "池",
      width: "100px"
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SalesName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "InvoiceAccount",
      label: "发票帐户",
      sortable: true
    },
    {
      key: "DeliveryDate",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "OrderAmountTax",
      label: "订单金额",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "OrderAmountWOTax",
      label: "本币不含税金额",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "TEC_Remark",
      label: "备注",
      sortable: true
    },
    {
      key: "TEC_FinalCustAccount",
      label: "最终客户",
      sortable: true
    },

    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "fcCheckIsSalesOderAllDispatched(t.id)",
      label: "状态",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    }
  ],
  //销售订单明细
  item_fields: [
    {
      key: "LineNum",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "valid_remain",
      label: "剩余派单数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "valid_approve",
      label: "待审批数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "SalesPrice",
      label: "价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "SalesPriceWOTax",
      label: "本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },

    {
      key: "ConfirmedDlv",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      width: "8rem",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "SEI_ProjectId",
      label: "项目编号",
      sortable: true
    },
    {
      key: "TEC_CommonRemark",
      label: "通用备注",
      sortable: true
    },
    {
      key: "TEC_CustSalesID",
      label: "客户订单号",
      sortable: true
    },
    {
      key: "SEI_OrderDateCust",
      label: "客户订单日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SEI_ShippingDateCust",
      label: "客户交期",
      sortable: true,
      type: "date"
    }
  ],
  //订单派发明细
  saleOrderItems_Detail_fileds: [
    {
      key: "LineNum",
      label: "订单明细行号",
      sortable: true,
      width: "60px"
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      editable: true,
      width: "80px"
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "qty",
      label: "数量",
      editable: true,
      type: "just_number",
      _precise: 6
    },

    {
      key: "price",
      label: "实际含税价",
      sortable: true,
      editable: false,
      type: "just_number",
      _precise: 6
    },
    {
      key: "PurchCurrencyCode",
      label: "实际含税价币种"
    },
    {
      key: "price_wotax",
      label: "实际采购本币净单价",
      type: "number",
      _precise: 6
    },
    {
      key: "price_remark",
      label: "价格备注",
      width: "8rem",
      type: "short"
    },
    {
      key: "price_vend",
      label: "初始含税报价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "price_vend_currency",
      label: "初始含税报价币种"
    },
    {
      key: "price_vend_wotax",
      label: "初始采购本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "Sales_Order_Price",
      label: "订单本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "TaxGroup",
      label: "供应商税组",
      sortable: true,
      thStyle: {
        width: "150px"
      }
    },
    {
      key: "quote_state",
      label: "价格状态",
      sortable: true,
      type: "state_icon"
    },
    {
      key: "Cost_Sum",
      label: "供应商成本",
      type: "number",
      _precise: 6
    },
    {
      key: "Sales_Cost",
      label: "价格协议成本",
      type: "number"
    },
    {
      key: "profit_state",
      label: "毛利状态",
      sortable: true,
      type: "state_icon"
    },
    {
      key: "profit_value",
      label: "毛利",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "invent_sum",
      label: "现有库存量",
      type: "number",
      _precise: 6
    },
    {
      key: "delivery_date",
      label: "装运日期",
      editable: true,
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      editable: true,
      type: "number"
    },
    {
      key: "PreDistributRate",
      label: "预分配比例(%)",
      type: "number"
    },
    {
      key: "DistributionRateChangedDes",
      label: "比例变更描述",
      editable: true,
      type: "textarea"
    },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      width: "8rem",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    }
  ],
  vend_quote_fileds: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      width: "80px"
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "qty",
      label: "数量",
      editable: true,
      type: "just_number"
    },

    {
      key: "price",
      label: "实际含税价",
      sortable: true,
      editable: false,
      type: "just_number",
      _precise: 6
    },
    {
      key: "PurchCurrencyCode",
      label: "实际含税价币种"
    },
    {
      key: "price_wotax",
      label: "实际采购本币净单价",
      type: "number",
      _precise: 6
    },
    {
      key: "price_remark",
      label: "价格备注",
      width: "8rem",
      type: "short",
    },
    {
      key: "price_vend",
      label: "初始含税报价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "price_vend_currency",
      label: "初始含税报价币种"
    },
    {
      key: "price_vend_wotax",
      label: "初始采购本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "Sales_Order_Price",
      label: "订单本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "TaxGroup",
      label: "供应商税组",
      sortable: true,
      thStyle: {
        width: "150px"
      }
    },
    {
      key: "quote_state",
      label: "价格状态",
      sortable: true,
      type: "state_icon"
    },
    {
      key: "Cost_Sum",
      label: "供应商成本",
      type: "number",
      thStyle: {
        width: "100px"
      }
    },
    {
      key: "Sales_Cost",
      label: "价格协议成本",
      type: "number",
      thStyle: {
        width: "120px"
      }
    },
    {
      key: "profit_state",
      label: "毛利状态",
      sortable: true,
      type: "state_icon"
    },
    {
      key: "profit_value",
      label: "毛利",
      sortable: true,
      type: "number",
      _precise: 6
    },
    { key: 'quotationType', label: '报价类型', sortable: true, thStyle: { width: "120px" } },
    {
      key: "invent_sum",
      label: "现有库存量",
      type: "number",
      _precise: 6
    },
    {
      key: "delivery_date",
      label: "装运日期",
      editable: true,
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      editable: true,
      type: "number"
    },
    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    }
  ]
}

const dataForm = {
  id: "",
  SalesLineId: "", //销售订单明细
  SalesId: "", ///销售订单编号
  ItemId: "",
  NameAlias: "",
  dataAreaId: "",
  AccountNum: "",
  SEI_Name: "",
  RetailVariantId: "", //变形编号
  VariantName: "", //变型名称
  price: 0,//实际采购价
  price_vend: 0,//初始报价
  price_vend_wotax: 0,//初始本币净单价
  price_currency: "CNY",//供应商价格确认币种
  price_vend_currency: "CNY",//供应商初始报价币种
  price_remark: "",//实际采购价备注
  profit_state: 0, //1--黄灯，0--红灯，2--绿灯
  profit_value: 0, //毛利
  quote_state: 0, //1--黄灯，0--红灯，2--绿灯
  Cost_Sum: 0, ///供应商成本
  Sales_Order_Price: 0, //订单价格
  Sales_Doc_Price: 0, //协议价格
  Sales_Cost: 0, //协议价格成本
  qty: 0,
  seq: 0,
  Capacity: 0,
  invent_sum: 0,
  delivery_date: "",
  PurchCurrencyCode: "",
  TaxGroup: "",
  TotalScore: 0, ///供应商评价
  description: "",
  price_tax: 0,
  price_wotax: 0,//实际采购本币净单价
  AXSalesId: "",
  AXInventTransId: "",
  AXPurchId: "",
  AXPurchInventTransId: "",
  AXSalesLineNum: "",
  AXPurchLineNum: "",
  isNullPurchPrice: false,
  DistributionRateChangedDes: "",
  isDistributionRateChanged: false,
  PreDistributRate: "",
  Accessory: ""
}

///前端验证
const rules = {}

const descriptor = {}
const methods = {
  //获取订单明细派发每个供应商已分配数量
  async getSODetailDispatchedVendQty(params) {
    let dis_biz_data = new biz_data_helper.base_entity_helper("get_so_detail_dispatch_vend_qty", {}, {})

    let result = await dis_biz_data.execAction({
      params: params,
      fields: []
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //获取预分配比例
  async getPreDistributionInDispatch(params) {
    let pre_dis_biz_data = new biz_data_helper.base_entity_helper("get_pre_distribution_in_dispatch", {}, {})

    let result = await pre_dis_biz_data.execAction({
      params: params,
      fields: []
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存数据至派单表,修改订单列表明细上的数量
  async saveDispatch(data, update_soline_form_list, so_data) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_SalesOrder_Dispatch",
      create,
      descriptor
    )
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "check_isExiste_vend_item",
      {},
      {}
    )
    //sp_updateApproveStatus
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus_PurchasePrice",
      {},
      {}
    )
    let _actions = []
    ///检查订单是否仍然是审核
    let check_so_approved_biz_data = new biz_data_helper.base_entity_helper(
      "CheckSOAllApproved",
      {},
      {}
    )
    ///后端剩余派单数量验证
    let if_can_modify_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesOrderDispatch",
      {},
      {}
    )
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status_dispatch",
      {},
      {}
    )
    ///修改剩余派单数量
    let update_soline_biz_data = new biz_data_helper.base_entity_helper(
      "update_sl_validremain",
      {},
      {}
    )
    _actions.push(
      check_so_approved_biz_data
        .execAction({
          params: {
            itemId: so_data.id
          },
          fields: ["isApproved"]
        })
        .action({
          output_last_item_map: {
            isApproved: "is_so_approved"
          }
        })
    )
    for (var i in data) {
      let _documentCreateByUsername = data[i].documentCreateByUsername
      ///====需求有变动暂时不检查供应商是否存在物料
      // let _companyid = data[i].DataArea;
      // _actions.push(
      //   check_biz_data
      //     .execAction({
      //       params: { dataAreaId: _companyid, ItemId: data[i].ItemId },
      //       fields: ["is_check_ok"]
      //     })
      //     .action({
      //       output_last_item_map: { is_check_ok: "is_check_ok" },
      //       rollback_when: { is_so_approved: { "=": false } }
      //     })
      // );
      let _is_internal = data[i].is_internal

      delete data[i].id
      delete data[i].DataArea
      delete data[i].documentCreateByUsername
      delete data[i].is_internal

      let _item_filed = _.map(fields.saleOrderItems_Detail_fileds, "key")
      _item_filed.push("id")
      ///检查是否能新增
      _actions.push(
        if_can_modify_biz_data
          .execAction({
            params: {
              SalesLineId: data[i].SalesLineId,
              CurrentDispathId: 0,
              action: "create",
              inputQty: data[i].qty
            },
            fields: ["allowed"]
          })
          .action({
            output_last_item_map: {
              allowed: "allowed"
            },
            // rollback_when: { is_check_ok: { "=": 1 } }
            rollback_when: {
              is_so_approved: {
                "=": false
              }
            }
          })
      )
      _actions.push(
        item_biz_data
          .insertAction({
            params: data[i],
            fields: _item_filed
          })
          .action({
            output_last_item_map: {
              id: "ItemId"
            },
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )

      ///审批(eq,neq,gt,gte,lt,lte，代表=，<>,>,>=,<,<=)
      let _DiffAmountCNY = 0, _MinusAmountCNY = 0, _LastDiffAmountCNY = 0
      _DiffAmountCNY =
        Math.abs(data[i].price_wotax - data[i].price_vend_wotax) * data[i].qty
      _MinusAmountCNY = Math.abs(data[i].price_vend_wotax - data[i].Sales_Order_Price) * data[i].qty
      _LastDiffAmountCNY = Math.abs(data[i].price_wotax - data[i].Sales_Cost) * data[i].qty
      let credit_form = {
        ItemId: "",
        DocumentType: "SalesOrderDispatch",
        ApproveType: "",
        DocumentCreateBy: _documentCreateByUsername,
        purch_price: data[i].price_wotax ? data[i].price_wotax : 0,
        initial_purch_price: data[i].price_vend_wotax ? data[i].price_vend_wotax : 0,
        sales_price: data[i].Sales_Order_Price ? data[i].Sales_Order_Price : 0,
        sales_cost: data[i].Sales_Cost ? data[i].Sales_Cost : 0,
        DiffAmountCNY: _DiffAmountCNY,
        MinusAmountCNY: _MinusAmountCNY,
        LastDiffAmountCNY: _LastDiffAmountCNY,
        is_internal: _is_internal
      }
      _actions.push(
        so_approve_biz_data
          .execAction({
            params: credit_form,
            fields: ["id"]
          })
          .action({
            mixin_last_item_map: {
              ItemId: "ItemId"
            }
            // rollback_when: { allowed: { "=": false } }
          })
      )
      if (_is_internal == 1) {
        _actions.push(
          update_status_biz_data
            .execAction({
              params: {
                IsApproved: 1,
                ApproveBy: _documentCreateByUsername,
                ItemId: "",
                DocumentType: "SalesOrderDispatch",
              }
            })
            .action({
              mixin_last_item_map: {
                ItemId: "ItemId"
              }
            })
        )
      }
    }
    if (update_soline_form_list && update_soline_form_list.length > 0) {
      _.each(update_soline_form_list, t => {
        _actions.push(
          update_soline_biz_data
            .execAction({
              params: {
                SalesLineId: t.id
              },
              fields: ["valid_remain", "valid_approve"]
            })
            .action({})
        )
      })
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  //获取订单列表
  async getData(_params) {
    let _fields = _.map(fields.default, "key")
    _fields.push("ExchRate")
    _fields.push("fcCheckSOAllApproved(t.id)")
    _fields.push("fcCheckIfSOItemHasVendPrice(t.id)")

    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //获取订单明细
  async getItemData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_SalesLineInfo",
      {},
      {}
    )
    let _fields = _.map(fields.item_fields, "key")
    _fields.push("id")
    _fields.push("SalesTable_id")
    let result = await item_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///获取所有供应商评价
  async getAllVendAssess(venders) {
    let assess_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_Rate",
      {},
      {}
    )
    let _fields = ["id", "VendAccountNum", "TotalScore"]
    let result = await assess_biz_data
      .selectAction({
        params: {
          is_deleted: {
            "=": 0
          },
          VendAccountNum: {
            "[]": venders
          }
        },
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///获取某物料有报价的供应商
  async getInventVendPrice(params) {
    let ivp_biz_data = new biz_data_helper.base_entity_helper(
      "get_vend_price_by_invent",
      {},
      {}
    )
    let _fields = [
      "TEC_CustAccount",
      "DW_CustName",
      "AccountNum",
      "SEI_Name",
      "TotalScore"
    ]
    let result = await ivp_biz_data
      .execAction({
        params: {
          ItemId: params.ItemId
        },
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  ///获取产能
  async getProductionCapacity(params) {
    let _actions = []
    const capacity_biz_data = new biz_data_helper.base_entity_helper(
      "get_vend_production_capacity",
      {},
      {}
    )
    _actions.push(
      capacity_biz_data
        .execAction({
          params: params,
          fields: ["ProductionCapacity "]
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _ProductionCapacity = 0

      _.each(result.data.BatchResult.Actions, t => {
        if (t.Result && t.Result.Data && t.Result.Data[0].length > 0) {
          _ProductionCapacity = t.Result.Data[0][0].ProductionCapacity
        }
      })
      return _ProductionCapacity
    } else {
      return false
    }
  },
  ///检查供应商是否存在某物料
  async checkIsInventInVender(_params) {
    let _actions = []
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "check_isExiste_vend_item",
      {},
      {}
    )
    _actions.push(
      check_biz_data
        .execAction({
          params: {
            dataAreaId: _params.dataAreaId,
            ItemId: _params.ItemId
          },
          fields: ["is_check_ok"]
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _is_ok = false
      _.each(result.data.BatchResult.Actions, t => {
        if (t.Result && t.Result.Data && t.Result.Data[0].length > 0) {
          _is_ok = t.Result.Data[0][0].is_check_ok == 0
        }
      })
      return _is_ok
    } else {
      return null
    }
  },
  async getDisDataStateAndInfo(_params) {
    let _actions = []
    const capacity_biz_data = new biz_data_helper.base_entity_helper(
      "get_vend_production_capacity",
      {},
      {}
    )
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "check_isExiste_vend_item",
      {},
      {}
    )
    let tax_biz_data = new biz_data_helper.base_entity_helper(
      "get_LocalAmountWOTax",
      {},
      {}
    )
    ///现有库存量
    let get_invent_sum_biz_data = new biz_data_helper.base_entity_helper(
      "get_vend_invent_sum",
      {},
      {}
    )
    _actions.push(
      capacity_biz_data
        .execAction({
          params: _params.get_pc,
          fields: ["ProductionCapacity "]
        })
        .action({})
    )
    _actions.push(
      check_biz_data
        .execAction({
          params: _params.check_vend_has_invent,
          fields: ["is_check_ok"]
        })
        .action({})
    )

    _actions.push(
      tax_biz_data
        .execAction({
          params: _params.amount_tax
        })
        .action({})
    )
    _actions.push(
      get_invent_sum_biz_data
        .execAction({
          params: _params.invent_sum_params
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///获取有报价的供应商
  async getHasQuoteVends(_params) {
    let _actions = []
    let biz_data = new biz_data_helper.base_entity_helper(
      "get_has_quote_vend",
      {},
      {}
    )

    _actions.push(
      biz_data
        .execAction({
          params: _params
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: _actions
    })
    //
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async saveLogClient(_params) {
    let _actions = []
    new biz_data_helper.base_entity_helper(
      "save_log_client",
      {},
      {})
    _actions.push(
      biz_data
        .execAction({
          params: _params
        })
        .action({})
    )
    await api.query_batch({
      actions: _actions
    })
  },
  async updateSODAxState(_params, log_data = null) {
    let _actions = []
    //1、审核派单
    if (!_.isNull(_params)) {
      let item_biz_data = new biz_data_helper.base_entity_helper(
        "sPlant_SalesOrder_Dispatch",
        create,
        descriptor
      )
      _actions.push(
        item_biz_data
          .updateAction({
            params: _params,
            fields: ["id"]
          })
          .action({})
      )
    }


    let result = await api.query_batch({
      actions: _actions
    }, log_data)
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return {
        state: true,
        data: [],
        message: ""
      }
    } else {
      return null
    }
  }
}
const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
export { biz_data, dataForm, fields, methods, rules }

